import { memo } from "react";
import { cn } from "utils";
import type { PriceDisplayProps } from "./types";

const PriceDisplay = ({
  text,
  priceData,
  classNames = {},
  hideUnitSymbol = false,
  currencySymbol = "$",
}: PriceDisplayProps) => {
  // 如果传入的是简单文本，直接显示
  if (text !== undefined) {
    return (
      <span
        className={cn(
          "headline_regular_l text-content_primary",
          classNames.container,
        )}
      >
        {!hideUnitSymbol && (
          <span className={cn(classNames.unitSymbol)}>{currencySymbol}</span>
        )}
        {text}
      </span>
    );
  }

  // 如果传入的是价格数据结构，使用复杂渲染逻辑
  if (priceData) {
    const { integerPart, leftDigits, zeroCount, isSuccess } = priceData;

    if (!isSuccess) {
      return (
        <span
          className={cn(
            "headline_regular_l text-content_primary",
            classNames.container,
          )}
        >
          --
        </span>
      );
    }

    return (
      <span
        className={cn(
          "headline_regular_l text-content_primary",
          classNames.container,
        )}
      >
        {!hideUnitSymbol && (
          <span className={cn(classNames.unitSymbol)}>{currencySymbol}</span>
        )}
        <span className={cn(classNames.integerPart)}>{integerPart}</span>
        {leftDigits ? (
          zeroCount ? (
            <>
              <span className={cn(classNames.decimalDot)}>.</span>
              <span className={cn(classNames.zeroText)}>0</span>
              <span
                className={cn(
                  "text-content_primary body_medium_l",
                  classNames.zeroCount,
                )}
                style={{ position: "relative", bottom: "-2px" }}
              >
                {zeroCount}
              </span>
              <span className={cn(classNames.leftDigits)}>{leftDigits}</span>
            </>
          ) : (
            <>
              <span className={cn(classNames.decimalDot)}>.</span>
              <span className={cn(classNames.leftDigits)}>{leftDigits}</span>
            </>
          )
        ) : null}
      </span>
    );
  }

  // 如果没有传入任何数据，显示占位符
  return (
    <span
      className={cn(
        "headline_regular_l text-content_primary",
        classNames.container,
      )}
    >
      --
    </span>
  );
};

export default memo(PriceDisplay);
